@if (billAccount) {
  <div id="billing-online-preference">
    <form [formGroup]="editOLBForm" (ngSubmit)="updateBillingPreferences()" class="pad-bottom-20">
      <p class="account-preferences-title"></p>
      @if ((dataLoading | async) === false) {
        <div>
          <div class="row">
            <div class="column twelve md-six">
              <ds-form-control-container
                [labelText]="'Billing Account Name'"
                [control]="editOLBForm.controls['accountName']"
              >
                <input
                  id="accountName"
                  class="fill"
                  formControlName="accountName"
                  maxlength="25"
                  data-cy="accountName"
                />
                <ds-form-control-message
                  [control]="editOLBForm.controls['accountName']"
                ></ds-form-control-message>
                <div class="row">
                  <div class="column twelve pad-top-10">
                    <ul class="criteria-list">
                      <li
                        [ngClass]="
                          accountName.hasError('invalidNickName') || accountName.value.length === 0
                            ? 'hasError'
                            : 'isValid'
                        "
                        class="pseudo-icon"
                      >
                        Letters, numbers and spaces only
                      </li>
                      <li
                        [ngClass]="
                          accountName.hasError('noMoreThanFourNumbers') ||
                          accountName.value.length === 0
                            ? 'hasError'
                            : 'isValid'
                        "
                        class="pseudo-icon"
                      >
                        Max 4 numbers
                      </li>
                      <li
                        [ngClass]="
                          editOLBForm.hasError('duplicateNickName') ||
                          accountName.value.length === 0
                            ? 'hasError'
                            : 'isValid'
                        "
                        class="pseudo-icon"
                      >
                        Unique account name
                      </li>
                    </ul>
                  </div>
                </div>
              </ds-form-control-container>
            </div>
            <div class="column twelve md-six md-pad-left-20">
              <ds-form-control-container
                [labelText]="'Email Reminder'"
                [control]="editOLBForm.controls['reminder']"
              >
                <select
                  id="reminder"
                  class="icon fill"
                  formControlName="reminder"
                  data-cy="reminder"
                >
                  @for (day of reminderOptions; track day) {
                    <option [value]="day">
                      {{ day }}
                      @if (day === 1) {
                        <span dsContent [contentPath]="'billing.dueDateText'"></span>
                      }
                      @if (day > 1 && day < 8) {
                        <span dsContent [contentPath]="'billing.dueDateAdditionalText'"></span>
                      }
                    </option>
                  }
                  <option value="-1" dsContent [contentPath]="'billing.noReminder'"></option>
                </select>
                <span class="icon-chevron-down"></span>
                <ds-form-control-message
                  [control]="editOLBForm.controls['reminder']"
                ></ds-form-control-message>
              </ds-form-control-container>
            </div>
          </div>
          <div class="row pad-top-20">
            <div class="column twelve flex items-center">
              <div class="flex items-center">
                <button
                  ds-button
                  type="submit"
                  [disabled]="
                    !editOLBForm.valid ||
                    (updatingPreferences | async) ||
                    (!accountName.dirty && !reminder.dirty) ||
                    (roleService.isAuthorized('editbillingpreferences') | async) === false
                  "
                  [attr.aria-label]="saveBtnContent"
                >
                  {{ saveBtnContent }}
                </button>
                @if (accountName.dirty || reminder.dirty) {
                  <a class="no-decoration caption pad-left-10" (click)="resetForm()">Cancel</a>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </form>
    @if (dataLoading | async) {
      <ds-localized-spinner
        [dataLoading]="dataLoading | async"
        [loadingMessage]="'Saving Your Preferences...'"
      >
      </ds-localized-spinner>
    }
  </div>
}
